export const menus = [
	{ is_header: true, title: "Navegación" },
	{ path: "/dashboard", icon: "bi bi-house", title: "Inicio" },
	{ path: "/accounts", icon: "bi bi-wallet2", title: "Cuentas" },
	{ path: "/purchases", icon: "bi bi-cart", title: "Compras" },
	{ path: "/ibs", icon: "fa fa-user-plus", title: "Gestion IBs" },
	{ path: "/positions", icon: "bi bi-bar-chart-line", title: "Historial" },
	{ path: "/reports", icon: "bi bi-file-earmark-text", title: "Reportes" },
	{ path: "/users", icon: "bi bi-people", title: "Usuarios" },
	{ path: "/copyTrading", icon: "bi bi-files", title: "Copy Trading" },
	{ path: "/tournaments", icon: "bi bi-trophy", title: "Torneos" },
];

export const ibMenu = [
	{ is_header: true, title: "Panel IB" },
	{ path: "/ibDashboard", icon: "bi bi-cpu", title: "Inicio" },
	{ path: "/ibUsers", icon: "bi bi-person-plus", title: "Referidos" },
	{ path: "/ibPurchases", icon: "bi bi-cash-stack", title: "Compras" },
];

export const AppIBDashboard = [
	{ is_header: true, title: "Panel Administrativo" },
	{ path: "/appIbDashboard", icon: "bi bi-cpu", title: "Inicio" },
	{ path: "/appIbUsers", icon: "bi bi-person-plus", title: "Clientes" },
	{ path: "/appIbPurchases", icon: "bi bi-cash-stack", title: "Compras" },
	{ path: "/appIbSignals", icon: "bi bi-person-plus", title: "Señales" },
	{ path: "/appIbEvents", icon: "bi bi-person-plus", title: "Eventos" },
];

export const affiliateMenu = [{ path: "/panel", icon: "bi bi-cpu", title: "Inicio" }];
